import token, { tokenToVars } from '../token';
import Avatar from './avatar';

export { Avatar };
export default tokenToVars(Avatar, token);
